import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CmsMediaCreateForm from 'domains/cms-media/create-form/cms-media-create-form'
import CmsMediaCardList from 'domains/cms-media/card-list/cms-media-card-list'
import CmsMediaApiV2 from 'api/v2/admins/cms-media-api-v2'
import { ALERT_TYPES } from 'constants/alert-constants'
import { LoaderButton } from 'components/molecules'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  }),
  label         : PropTypes.string,
  onClickSubmit : PropTypes.func
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  },
  label         : '',
  onClickSubmit : () => {}
}

const CmsMediaSidebar = ({ pageUtils, onClickSubmit }) => {
  const [ isCmsMediaDrawerOpen, setIsCmsMediaDrawerOpen ] = useState(false)
  const [ cmsMedia, setCmsMedia ]                         = useState([])
  const [ selectedCmsMedia, setSelectedCmsMedia ]         = useState({})
  const [ pagination, setPagination ]                     = useState({})
  const [ isSubmitted, setIsSubmitted ]                   = useState(false)
  const [ filters, setFilters ]                           = useState({
    page     : 1,
    per_page : 8
  })

  const openDrawer = () => {
    setIsCmsMediaDrawerOpen(!isCmsMediaDrawerOpen)
  }

  useEffect(() => {
    CmsMediaApiV2.get({ params: filters })
      .then((response) => {
        setCmsMedia(response.data.media)
        setPagination(response.data.meta)
      })
      .catch((error) => alert(error.message))
  }, [ filters, isSubmitted ])

  const handleSubmitForm = async (values, actions) => {
    const payload = new FormData()
    const images  = values.images
    const key     = 'images[]'

    images.map((image) => {
      payload.append(key, image)
    })

    CmsMediaApiV2.create({ payload })
      .then(() => {
        pageUtils.setAlertMsg('Cms Media has been uploaded', ALERT_TYPES.SUCCESS)
        actions.resetForm()
        setIsSubmitted(!isSubmitted)
      })
      .catch((error) => alert(error.message))
  }

  const handleClickPage = (page) => {
    setFilters({
      ...filters,
      page: page
    })
  }

  const handleClickMedia = (media) => {
    setSelectedCmsMedia(media)
  }

  const handleClickSubmit = (media) => {
    setSelectedCmsMedia(media)
    onClickSubmit(media)
    openDrawer()
  }

  return (
    <>
      <CmsMediaCreateForm
        handleSubmitForm={ handleSubmitForm }
      />
      <CmsMediaCardList
        cmsMedia={ cmsMedia }
        onClickPage={ handleClickPage }
        onClickMedia={ handleClickMedia }
        onDoubleClickMedia={ (media) => handleClickSubmit(media) }
        pagination={ pagination }
      />
      <LoaderButton
        className='w-100'
        onClick={ () => handleClickSubmit(selectedCmsMedia) }
        block={ false }
        color='primary'
        text="Submit"
      />
    </>
  )
}

CmsMediaSidebar.propTypes    = propTypes
CmsMediaSidebar.defaultProps = defaultProps

export default CmsMediaSidebar
